module.exports = __webpack_public_path__ + "fonts/NunitoSans-VariableFont_YTLC,opsz,wdth,wght.61b71ee.ttf";